import { __PLANET_MEDIA_PLAYER_VERSION__ } from '../../constants';
import { HttpClient, HttpMethod, HttpRequest, HttpRequestError, HttpResponse, IContextSnapshot } from '../../utils';
import { AnalyticsTransportOptions } from './analytics-transport-options';
import { BulkError } from './bulk-error';
import { BulkResult } from './bulk-result';
import { BulkSuccess } from './bulk-success';

export class AnalyticsTransport {

    private readonly http: HttpClient = new HttpClient();
    private readonly url: string;
    private readonly traceId: string;
    private readonly syncFrequency: number = 1;
    private syncTimeout: number = 1000;

    private readonly defaultHeaders: { [key: string]: string } = {
        'x-planet-tracker-version': __PLANET_MEDIA_PLAYER_VERSION__,
        'content-type': 'application/octet-stream',
    };

    constructor(options: AnalyticsTransportOptions) {
        this.url = options.baseUrl;
        this.syncFrequency = options.frequency;
        this.syncTimeout = 1000 / this.syncFrequency;
        this.traceId = options.traceId;
    }

    beacon(messages: IContextSnapshot): void {
        const url: string = `${this.url}/intake/${this.traceId}/events`;
        this.http.beacon(url, JSON.stringify(messages), {
            'beacon': 'true',
            'x-planet-tracker-version': __PLANET_MEDIA_PLAYER_VERSION__,
        });
    }

    async postBulkRequest(messages: IContextSnapshot): Promise<BulkResult> {
        return new Promise((resolve, reject) => {
            const url: string = `${this.url}/intake/${this.traceId}/events`;
            const request: HttpRequest = this.http.request(HttpMethod.Post, url, {
                ...this.defaultHeaders,
            }, {timeout: 5000});
            request.setBody(JSON.stringify(messages, (key, value) => {
                if (typeof value === 'number' && value % 1 !== 0) {
                    return Number(value.toFixed(2));
                }
                return value;
            }));
            request.sendAsync()
                .then((response: HttpResponse) => {
                    if (response.isSuccessStatusCode) {
                        resolve(new BulkSuccess(request, response.statusCode));
                    } else {
                        reject(new BulkError(request, response.statusCode));
                    }
                })
                .catch((error: HttpRequestError) => {
                    reject(new BulkError(request, error.status));
                });
        });
    }

}

